<template>
  <div class="product-configs-container">
    <div v-if="headline" class="product-configs-headline">
      {{ headline }} -
      <span class="product-configs-value">{{ selected }}</span>
    </div>

    <div class="product-configs">
      <BaseProductColorConfigurationItem
        v-for="(item, index) in items"
        :key="index"
        :title="item[keyTitle]"
        :selected="item[keySelected] === selected"
        :color="item.color_hex"
        :isShowCancelIcon="
          (isFromQRCode && item[keySelected] !== selected) ||
            item.disabled
        "
        :disabled="
          (isFromQRCode && item[keySelected] !== selected) ||
            item.disabled
        "
        @click="isFromQRCode ? null : $emit('change', item)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProductColorConfigurations',

  props: {
    headline: {
      type: String,
      default: '',
    },
    keyTitle: {
      type: String,
      required: true,
    },
    keySelected: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    isFromQRCode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseProductColorConfigurationItem: () =>
      import(
        '@/components/base/product/BaseProductColorConfigurationItem'
      ),
  },
}
</script>

<style lang="stylus" scoped>
.product-configs-container
	display flex
	flex-direction column
	gap: 16px

// BaNANA Styles
.-is-bnn {
	.product-configs {
		display: flex;
		// flex-wrap: nowrap;
		gap: 16px;

		@media screen and (max-width: 768px) {
			flex-direction: row;
		}
	}

	.product-configs-headline {
		font-size: 14px
		color: rgba(0, 0, 0, 0.45);
	}

	.product-configs-value {
		text-transform: capitalize;
		font-weight: 600;
		color: rgba(0, 0, 0, 0.85);
	}
}

// Studio7 Styles
.product-configs{
	display: flex;
	flex-wrap: wrap;
	gap: 16px;

	@media screen and (max-width: 768px) {
		// flex-direction: row;
	}
}
</style>
